import type { NextPage } from 'next'
import styles from './optionsButton.module.scss'
import { BsThreeDotsVertical } from 'react-icons/bs'

interface Props {
  onClick: () => void
}
const OptionsButton: NextPage<Props> = (props: Props) => {
  return <div onClick={props.onClick} className={styles.OptionsButton}>
    <BsThreeDotsVertical />
  </div>
}

export default OptionsButton
